export default () => ({
    flow: sessionStorage.getItem('profile-flow') || 'completed',
    sessionType: sessionStorage.getItem('session-type') || null
})